import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { AppContext } from "../../Context/AppContext";
import { MODULES } from "../../Helpers/Constants";

const cookies = new Cookies();

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { modules } = useContext(AppContext);

  const getDefaultRoute = () => {
    // Ensure modules is available and is an array
    if (!modules || !Array.isArray(modules)) {
      return "/profile";
    }

    // Check if user has access to Order Lookup
    const orderLookupAccess = modules.find(
      (module) => module.name === MODULES.ORDER_LOOKUP
    );
    if (orderLookupAccess && orderLookupAccess.permissions.read_access) {
      return "/admin/orders/list";
    }

    // Check if user has access to Dashboard
    const dashboardAccess = modules.find(
      (module) => module.name === MODULES.DASHBOARD
    );
    if (dashboardAccess && dashboardAccess.permissions.read_access) {
      return "/dashboard";
    }

    // Default to profile
    return "/profile";
  };

  useEffect(() => {
    const requireAuth = () => {
      const allowPath = ["/login", "/forgot-password", "/reset-password"];
      const currentPath = location.pathname;

      if (cookies.get("accessToken")) {
        // User is authenticated
        if (allowPath.includes(currentPath)) {
          navigate(getDefaultRoute());
        }
      } else {
        // User is not authenticated
        if (!allowPath.includes(currentPath)) {
          window.location.href = "/login";
        }
      }
    };

    requireAuth();
  }, [location.pathname, cookies.get("accessToken"), modules]);

  return (
    <>
      {children}
    </>
  )
};

export default ProtectedRoute;
